import services from '../assets/js/services'
export default {
    state: {
        activityTerm: [], // 实践学期
        activityClass: [], // 实践班级  getSchoolActivityClass
        trainCourse: [], // 课程列表
        workDetail: {}, // 作业详情
    },
    getters: {
    },
    actions: {
        // 获取实践学期
        getActivityTerm (context, payload) {
            return services.getSchoolActivityTerm(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setActivityTerm', {
                        'data': res.data ? res.data : {}
                    })
                }
                return res;
            })
        },

        // 获取实践班级
        getActivityClass (context, payload) {
            return services.getSchoolActivityClasses(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setActivityClass', {
                        'data': res.data ? res.data : {}
                    })
                }
                return res;
            })
        },

        // 获取课程列表
        getTrainCourse (context, payload) {
            return services.getSchoolTrainCourse(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setTrainCourse', {
                        'data': res.data ? res.data : {}
                    })
                }
                return res;
            })
        },
        // 获取作业详情
        getWorkDetail (context, payload) {
            return services.getSchoolWorkDetail(payload).then(res => {
                if (res.code == '0000') {
                    context.commit('setWorkDetail', {
                        'data': res.data ? res.data : {}
                    })

                }
                return res;
            })
        },
        // 批阅作业
        postWorkScore (context, payload) {
            return services.postWorkScore(payload).then(res => {
                return res;
            })
        },
        // 获取任务作业列表
        getSchoolTaskWorkList(context, payload) {
            return services.getSchoolTaskWorkList(payload).then(res => {
                return res;
            })
        },
        // 任务 - 导出成绩
        getSchoolTaskExportScore(context, payload) {
            return services.getSchoolTaskExportScore(payload).then(res => {
                return res;
            })
        },
        // 任务 - 导出附件
        getSchoolTaskExportAttach(context, payload) {
            return services.getSchoolTaskExportAttach(payload).then(res => {
                return res;
            })
        },
        // 任务 - 下载附件
        getSchoolTaskDownAttach(context, payload) {
            return services.getSchoolTaskDownAttach(payload).then(res => {
                return res;
            })
        },
    },
    mutations: {
        // 设置实践学期
        setActivityTerm (state, payload) {
            state.activityTerm = payload.data;
        },
        // 设置实践班级
        setActivityClass (state, payload) {
            if(payload.data && payload.data.items){
                state.activityClass = payload.data.items;
            } else {
                state.activityClass = [];
            }
        },
        // 设置课程列表
        setTrainCourse (state, payload) {
            state.trainCourse = payload.data;
        },
        // 设置作业详情
        setWorkDetail (state, payload) {
            state.workDetail = payload.data;
        },
    }
}